/*
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-12-03 12:07:17
 * @LastEditors: YH000644 weirongwei@danghuan.com
 * @LastEditTime: 2024-12-03 12:11:44
 * @FilePath: \eu-eswop-official-site\src\locales\index.js
 * @Description:
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'

// 引入自定义语言配置
import zh from './lang/zh.js'
import en from './lang/en.js'
import es from './lang/es.js'
import fr from './lang/fr.js'
import de from './lang/de.js'

// 引入UI框架语言配置---elementui
import iviewZH from 'element-ui/lib/locale/lang/zh-CN.js'
import iviewEN from 'element-ui/lib/locale/lang/en.js'
import iviewES from 'element-ui/lib/locale/lang/es.js'
import iviewFR from 'element-ui/lib/locale/lang/fr.js'
import iviewDE from 'element-ui/lib/locale/lang/de.js'

const hash = window.location.hash; // "#/page?nationCode=CH&channelId=114030"
const queryString = hash.split('?')[1]; // "nationCode=CH&channelId=114030"
const urlParams = new URLSearchParams(queryString);

const nationCode = urlParams.get('nationCode') || 'es';

console.log("nationCode", nationCode)

const nationObj = {
  GB: 'en',
  FR: 'fr',
  ES: 'es'
}


Vue.use(VueI18n)

const localeMapping = {
  zh: {
    name: 'ZH',
    value: 'zh',
    langFile: zh,
    iViewLangeFile: iviewZH,
    acceptLanguage: 'zh_CN',
  }, 
  en: {
    name: 'EN',
    value: 'en',
    langFile: en,
    iViewLangeFile: iviewEN,
    acceptLanguage: 'en_US',
  },
  es: {
    name: 'ES',
    value: 'es',
    langFile: es,
    iViewLangeFile: iviewES,
    acceptLanguage: 'es_ES',
  },
  fr: {
    name: 'FR',
    value: 'fr',
    langFile: fr,
    iViewLangeFile: iviewFR,
    acceptLanguage: 'fr_FR',
  }
};

const defaultLang = nationObj[nationCode] || 'es'
const lang =  nationObj[nationCode] || 'es';
const isES = lang === defaultLang;

console.log(lang)

// 设置后台语言的请求头
const customRequestHeader = {
  'Accept-Language': localeMapping[lang].acceptLanguage,
  'name': localeMapping[lang].name
};
const i18n = new VueI18n({
  locale: lang
})

i18n.setLocaleMessage(lang, Object.assign(localeMapping[lang]?.langFile, localeMapping[lang]?.iViewLangeFile))

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

const vm = new Vue({ i18n })

// 切换语言方法
Vue.prototype.$toggleLang = (lang = defaultLang) => {
  sessionStorage.setItem('lang', lang)
  window.location.reload()
}

if (window.location.hostname !== 'localhost') {
  // 本地开发展示中文
  delete localeMapping.zh
}
export {
  i18n,
  localeMapping,
  lang,
  vm,
  isES,
  customRequestHeader
}
